exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Cookies{left:50%;bottom:5px;width:100%;display:flex;position:fixed;max-width:856px;min-height:50px;margin-left:-428px;border-radius:4px;align-items:center;padding:8px 16px 12px;background-color:#fff;justify-content:space-around;border-bottom:5px solid #3cbce6;box-shadow:0 2px 12px -2px}.Cookies-content-ancor,.Cookies-content-description{font-size:12px;font-weight:100}.Cookies-content-description{color:#222831}.Cookies-content-ancor{color:#3ab8e8;text-decoration:underline}.Cookies-button{padding:8px 20px;font-size:12px;font-weight:400;display:flex;justify-content:center;align-items:center;margin-left:16px;border-radius:4px;background-color:#3cbce6;color:#fff;height:32px;width:112px;min-width:112px;cursor:pointer}@media (max-width:640px){.Cookies{left:0;margin-left:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-661da59c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Cookies/Cookies.vue
// module id = 203
// module chunks = 0